import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const HighlightIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue6d1'}</MuiIcon>
        );
    })